import { z } from 'zod';
import { createFormController } from '../tier0/form-controller.mjs';

// Presentation intent only. DATA/PUB adapters bind current row versions,
// preview/approval and permissions; this is never a C8 mutation or receipt.
const moveIntent = z
  .object({
    itemId: z.string().min(1).max(200),
    beforeId: z.string().min(1).max(200).nullable(),
    columnId: z.string().min(1).max(200).optional(),
  })
  .strict();
export function createReorderController({ commit, classifyResult, reconcile, onInvalidate }) {
  return createFormController({
    fields: [{ id: 'move', name: 'move', type: 'json', required: true }],
    complexValidators: { json: (value) => moveIntent.safeParse(value).success },
    submit: ({ operationId, values, signal }) =>
      commit({ operationId, intent: moveIntent.parse(values.move), signal }),
    classifyResult,
    reconcile: reconcile && ((attempt) => reconcile(attempt.operationId)),
    onInvalidate,
  });
}
